import React from "react";
import { Box, TextField } from "@mui/material";
import CurrentSDMLoansTable from "./CurrentSDMLoansTable";
import OtherLoansTable from "./OtherLoansTable";
import SelectField from "./SelectField";

const COMPANY_TYPE_OPTIONS = [
  "кредитуется в банке с",
  "ранее в банке не кредитовалась"
];

const LoansTab = ({ data, onUpdate }) => {
  const updateField = (path, value) => {
    onUpdate(path, value);
  };

  return (
    <Box>
      {/* Section: Company Credit Status */}
      <Box sx={{ marginBottom: "32px" }}>
        <Box sx={{
          display: "flex",
          gap: "16px",
          marginBottom: "16px",
          alignItems: "flex-start"
        }}>
          <Box sx={{ flex: 1 }}>
            <SelectField
              label="Компания / группа компаний /"
              value={data.loans?.companyTakesLoan ? "кредитуется в банке с" : "ранее в банке не кредитовалась"}
              onChange={(val) => updateField("loans.companyTakesLoan", val === "кредитуется в банке с")}
              options={COMPANY_TYPE_OPTIONS}
            />
          </Box>

          {data.loans?.companyTakesLoan && (
            <Box sx={{ flex: 0, minWidth: "120px" }}>
              <TextField
                placeholder="Год"
                value={data.loans?.companyTakesLoanSince || ""}
                onChange={(e) => updateField("loans.companyTakesLoanSince", e.target.value)}
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                }}
              />
            </Box>
          )}
        </Box>

        <Box sx={{ marginBottom: "16px" }}>
          <Box sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#1A1E24",
            marginBottom: "8px"
          }}>
            Замечания по обслуживанию кредитов в СДМ-БАНКе, кредитная история:
          </Box>
          <TextField
            value={data.loans?.loansServicingNotes || ""}
            onChange={(e) => updateField("loans.loansServicingNotes", e.target.value)}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "14px",
              },
            }}
          />
        </Box>
      </Box>

      {/* Section: Current SDM Loans */}
      <Box sx={{ marginBottom: "32px" }}>
        <CurrentSDMLoansTable
          data={data.loans?.currentSdmLoans || []}
          onChange={(newData) => updateField("loans.currentSdmLoans", newData)}
        />
      </Box>

      {/* Section: Other Loans */}
      <Box sx={{ marginBottom: "32px" }}>
        <OtherLoansTable
          data={data.loans?.otherLoans || []}
          onChange={(newData) => updateField("loans.otherLoans", newData)}
        />

        <Box sx={{ marginTop: "16px" }}>
          <Box sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#1A1E24",
            marginBottom: "8px"
          }}>
            Информация по обслуживанию кредитов в других банках:
          </Box>
          <TextField
            value={data.loans?.otherLoansDetails || ""}
            onChange={(e) => updateField("loans.otherLoansDetails", e.target.value)}
            multiline
            rows={3}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "14px",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LoansTab;
